// Mock data para Obrador Pomodoro

export const menuData = {
  entradas: [
    {
      id: 1,
      nombre: "Bruschetta Clásica",
      descripcion: "Pan tostado con tomate fresco, albahaca y aceite de oliva",
      precio: 8500
    },
    {
      id: 2,
      nombre: "Tabla de Fiambres Italianos",
      descripcion: "Selección de prosciutto, salame, mortadela y quesos",
      precio: 15000
    },
    {
      id: 3,
      nombre: "Provoleta a la Parrilla",
      descripcion: "Queso provolone grillado con oregano y tomate",
      precio: 9000
    },
    {
      id: 4,
      nombre: "Arancini de Azafrán",
      descripcion: "Bolitas de risotto rellenas y fritas",
      precio: 10000
    }
  ],
  pastas: [
    {
      id: 5,
      nombre: "Tortellini a la Crema",
      descripcion: "Tortellini rellenos de ricotta con salsa de crema y nuez moscada",
      precio: 16500
    },
    {
      id: 6,
      nombre: "Tagliatelle al Ragú",
      descripcion: "Pasta fresca con salsa boloñesa de cocción lenta",
      precio: 15000
    },
    {
      id: 7,
      nombre: "Ravioles de Espinaca",
      descripcion: "Ravioles caseros con manteca, salvia y parmesano",
      precio: 14500
    },
    {
      id: 8,
      nombre: "Spaghetti Carbonara",
      descripcion: "Pasta con panceta, huevo, parmesano y pimienta negra",
      precio: 14000
    },
    {
      id: 9,
      nombre: "Ñoquis de Papa",
      descripcion: "Ñoquis artesanales con salsa a elección: tuco, pesto o fileto",
      precio: 13500
    }
  ],
  principales: [
    {
      id: 10,
      nombre: "Ossobuco a la Milanesa",
      descripcion: "Osobuco braseado con risotto azafranado",
      precio: 28000
    },
    {
      id: 11,
      nombre: "Milanesa Napolitana",
      descripcion: "Milanesa de ternera con jamón, tomate y mozzarella, acompañada de papas fritas",
      precio: 18000
    },
    {
      id: 12,
      nombre: "Pollo al Marsala",
      descripcion: "Pechuga de pollo con salsa de marsala y champiñones",
      precio: 17500
    },
    {
      id: 13,
      nombre: "Risotto de Hongos",
      descripcion: "Risotto cremoso con hongos portobello y trufa",
      precio: 16000
    }
  ],
  postres: [
    {
      id: 14,
      nombre: "Tiramisú Casero",
      descripcion: "Clásico postre italiano con café y mascarpone",
      precio: 8000
    },
    {
      id: 15,
      nombre: "Panna Cotta",
      descripcion: "Crema italiana con coulis de frutos rojos",
      precio: 7500
    },
    {
      id: 16,
      nombre: "Cannoli Siciliano",
      descripcion: "Masa crujiente rellena de ricotta dulce y chips de chocolate",
      precio: 8500
    },
    {
      id: 17,
      nombre: "Affogato",
      descripcion: "Helado de vainilla con espresso caliente",
      precio: 6500
    }
  ],
  bebidas: [
    {
      id: 18,
      nombre: "Vino Tinto de la Casa",
      descripcion: "Copa de Malbec o Cabernet",
      precio: 5000
    },
    {
      id: 19,
      nombre: "Aperol Spritz",
      descripcion: "Cóctel italiano con Aperol, prosecco y soda",
      precio: 7000
    },
    {
      id: 20,
      nombre: "Espresso",
      descripcion: "Café italiano tradicional",
      precio: 3500
    },
    {
      id: 21,
      nombre: "Limonada Casera",
      descripcion: "Limonada fresca con hierbas",
      precio: 4000
    }
  ]
};

export const reviews = [
  {
    id: 1,
    nombre: "María González",
    rating: 5,
    comentario: "Nos sentimos como en Italia. La comida es exquisita y la atención es increíble. El ambiente es espectacular.",
    fecha: "Hace 2 semanas"
  },
  {
    id: 2,
    nombre: "Carlos Fernández",
    rating: 5,
    comentario: "Muy buena la comida y la atención. Los panificados riquísimos. Volvería sin dudar.",
    fecha: "Hace 1 mes"
  },
  {
    id: 3,
    nombre: "Lucía Martínez",
    rating: 5,
    comentario: "Lugar canchero, comida de primera calidad. El menú de mediodía tiene excelente precio.",
    fecha: "Hace 3 semanas"
  },
  {
    id: 4,
    nombre: "Roberto Silva",
    rating: 5,
    comentario: "Todo increíble. La atención fue lo mejor, muy rápida y atenta. Esperamos menos de 10 minutos.",
    fecha: "Hace 1 semana"
  },
  {
    id: 5,
    nombre: "Ana Rodríguez",
    rating: 5,
    comentario: "Excelente experiencia. Ideal para almuerzos y cenas. El tiramisú es espectacular.",
    fecha: "Hace 2 semanas"
  },
  {
    id: 6,
    nombre: "Javier López",
    rating: 5,
    comentario: "Ambientación cuidada, servicio impecable. Facundo nos atendió genial, muy profesional.",
    fecha: "Hace 4 días"
  }
];

export const experiences = [
  {
    icon: "Users",
    title: "Nos sentimos como en Italia",
    description: "Cada detalle está pensado para transportarte a la auténtica experiencia italiana"
  },
  {
    icon: "Utensils",
    title: "Comida exquisita",
    description: "Ingredientes de primera calidad preparados con técnicas tradicionales"
  },
  {
    icon: "Sparkles",
    title: "Ambientación espectacular",
    description: "Un espacio cálido y elegante perfecto para cualquier ocasión"
  },
  {
    icon: "TrendingUp",
    title: "Lugar canchero",
    description: "Moderno y sofisticado sin perder la calidez del servicio italiano"
  },
  {
    icon: "Coffee",
    title: "Panificados riquísimos",
    description: "Pan y focaccias horneados diariamente en nuestro obrador"
  },
  {
    icon: "DollarSign",
    title: "Excelente precio",
    description: "Menú de mediodía con relación calidad-precio inigualable"
  }
];
